export const NEW_NOTIFICATION = "new_notification";
export const CLEAR_NOTIFICATION = "clear_notification";